import RichTextSubmissionViewer from 'components/Grading/RichTextSubmissionViewer';
import { useEvidenceReview } from 'contexts/evidenceReview';

const EvidenceRichTextSubmissionViewer = (props) => {
    const review = useEvidenceReview();

    return (
        <RichTextSubmissionViewer
            {...props}
            autoScrollFirstHighlight={false}
            navigationRequest={review?.navigationRequest}
            onNavigationComplete={review?.completeNavigationRequest}
        />
    );
};

export default EvidenceRichTextSubmissionViewer;
